module.exports = __webpack_public_path__ + "img/home_new_2.6b93670f.jpg";